<div class="min-h-screen relative overflow-hidden bg-gray-100 flex items-center justify-center md:block">

  <!-- Background -->
  <div class="absolute inset-y-0 left-0 w-[80%] hidden md:block">
    <img src="../assets/Login_page.png" class="w-full h-full object-cover" alt="Login Background" />
  </div>

  <!-- Card -->
  <div class="relative w-full max-w-md bg-white rounded-2xl shadow-2xl px-10 py-12 mx-4
              md:absolute md:right-[7%] md:top-1/2 md:-translate-y-1/2">

    <!-- Logo -->
    <div class="text-center mb-6">
      <img src="https://www.hubblehox.com/wp-content/uploads/2025/01/hubblehox-favicon.png?v=2" class="w-12 h-12 mx-auto mb-4" />
    </div>

    <form *ngIf="mode === 'login'" [formGroup]="loginForm" class="space-y-5">

      <p class="font-['Roboto'] font-semibold text-[36px] ">Login</p>

      <!-- STAFF -->
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-[10px]" *ngIf=" user_type==='staff'">
          <p class=" font-normal text-[18px]">Email ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" formControlName="email" label="Email ID" placeholder="Enter Email ID"> </app-text-input>
        </div>

        <div class="flex flex-col gap-[10px]" *ngIf=" user_type==='student'">
          <p class=" font-normal text-[18px]">User ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" [is_required]="true" class="w-full" placeholder="Enter User ID" [label]="'User Id'" formControlName="roll_number"></app-text-input>
        </div>

        <div class="flex flex-col gap-[10px]">
          <p class="font-normal text-[18px]">Password</p>
          <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" (keyup.enter)="submit()" type="password" [mask]="true" [is_required]="true" class="w-full" placeholder="Enter Password" [label]="'Password'" formControlName="password"></app-text-input>
        </div>
      </div>
      <div class="flex flex-col items-center gap-4 w-full">
        <button type="button" (click)="submit()" class="flex items-center justify-center gap-2 w-[144px] py-3 text-white font-medium rounded-xl 
           bg-gradient-to-r from-[#4A76B8] to-[#2D5EAB] hover:opacity-90 transition"> Login <span class="text-xl felx justify-center items-center">→</span>
        </button>
        <p *ngIf="params.user_type !== 'student'" class="text-[#2D5EAB] text-[16px] font-medium cursor-pointer hover:underline" (click)="openForgotPassword()"> Forgot Password </p>
      </div>
    </form>

    <form *ngIf="mode === 'forgot'" [formGroup]="forgotForm" class="space-y-5">

      <h2 class="text-2xl font-semibold text-gray-800">Forgot Password</h2>

      <!-- STEP 1 : EMAIL -->
      <ng-container *ngIf="forgotStep === 1">
        <div class="flex flex-col gap-[10px]" *ngIf=" user_type==='staff'">
          <p class=" font-normal text-[18px]">Email ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" [is_required]="true" class="w-full" placeholder="Enter Email ID" [label]="'Email'" formControlName="email"></app-text-input>
        </div>
        <div class="flex flex-col gap-[10px]" *ngIf="user_type === 'student'">
          <p class=" font-normal text-[18px]">User ID</p>
          <app-text-input [img]="'../../../assets/solar_user-broken.png'" [is_login]="true" [is_required]="true" class="w-full" placeholder="Enter User ID" [label]="'User Id'" formControlName="roll_number"></app-text-input>
        </div>
        <div class="flex flex-col items-center gap-4 w-full">
          <button type="button" (click)="sendOtp()" class="flex items-center justify-center gap-2 w-[144px] py-3 text-white font-medium rounded-xl 
           bg-gradient-to-r from-[#4A76B8] to-[#2D5EAB] hover:opacity-90 transition"> Send OTP <span class="text-xl felx justify-center items-center">→</span>
          </button>
        </div>
      </ng-container>

      <!-- STEP 2 : OTP -->
      <ng-container *ngIf="forgotStep === 2">
        <div>
          <div class="flex justify-between">
            <label class="text-sm text-gray-600">Enter OTP</label>
            <p class="text-center text-sm text-gray-600 mt-3">
              OTP expires in
              <span class="text-red-600 font-semibold">{{ otpTime }}</span>
            </p>
          </div>
          <div class="flex flex-col gap-2">
            <div class="flex justify-between gap-2 mt-2">
              <input *ngFor="let box of otpBoxes; let i = index" type="text" maxlength="1" class="w-12 h-12 border rounded-lg text-center text-xl focus:outline-blue-500" (input)="onOtpInput($event, i)" (keydown)="onOtpKeyDown($event, i)" />

            </div>
            <p *ngIf="otpError" class="text-red-500 text-sm mt-2 text-center">
              {{ otpError }}
            </p>
          </div>
        </div>

        <!-- RESEND -->
        <p class="text-end text-sm mt-2">
          <button class="text-blue-600 font-medium disabled:text-gray-400" [disabled]="!canResendOtp" (click)="resendOtp()">
            Resend OTP
          </button>
        </p>

        <div class="flex flex-col items-center gap-4 w-full">
          <button type="button" (click)="verifyOtp()" class="flex items-center justify-center gap-2 w-[144px] py-3 text-white font-medium rounded-xl 
           bg-gradient-to-r from-[#4A76B8] to-[#2D5EAB] hover:opacity-90 transition"> Verify OTP <span class="text-xl felx justify-center items-center">→</span>
          </button>
        </div>
      </ng-container>



      <!-- STEP 3 : RESET PASSWORD -->
      <ng-container *ngIf="forgotStep === 3">
        <div class="flex flex-col gap-3">
          <div class="flex flex-col gap-[10px]">
            <p class="font-normal text-[18px]">New Password</p>
            <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'New Password'" formControlName="new_password"></app-text-input>
          </div>
          <div class="flex flex-col gap-[10px]">
            <p class="font-normal text-[18px]">Confirm Password</p>
            <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'Confirm Password'" formControlName="confirm_password"></app-text-input>
          </div>
          <p *ngIf="forgotForm.get('new_password')?.invalid && forgotForm.get('new_password')?.touched" class="text-red-500 text-xs -mt-2">
            <ng-container *ngIf="forgotForm.get('new_password')?.hasError('required'); else pwdMinLen1">New Password is required</ng-container>
            <ng-template #pwdMinLen1><ng-container *ngIf="forgotForm.get('new_password')?.hasError('minlength'); else pwdPattern1">Minimum 8 characters required</ng-container></ng-template>
            <ng-template #pwdPattern1>Must include uppercase, lowercase, number and special character</ng-template>
          </p>
        </div>
        <p *ngIf="forgotForm.hasError('passwordMismatch') && forgotForm.get('confirm_password')?.touched" class="text-red-500 text-sm text-center">
          Passwords do not match
        </p>
        <button [disabled]="reset_form.value.new_password !== reset_form.value.confirm_password" type="button" class="w-full bg-blue-600 text-white py-3 rounded-lg" (click)="resetPassword()">
          Reset Password →
        </button>
      </ng-container>

      <p class="text-center text-sm text-gray-600 cursor-pointer" (click)="backToLogin()">
        ← Back to Login
      </p>

    </form>

  </div>
</div>

<app-modal #form_modal label="Reset Password">
  <form [formGroup]="reset_form">
    <div class="flex flex-col gap-4">
      <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'New Password'" formControlName="new_password"></app-text-input>
      <p *ngIf="reset_form.get('new_password')?.invalid && reset_form.get('new_password')?.touched" class="text-red-500 text-xs -mt-2">
        <ng-container *ngIf="reset_form.get('new_password')?.hasError('required'); else pwdMinLen2">New Password is required</ng-container>
        <ng-template #pwdMinLen2><ng-container *ngIf="reset_form.get('new_password')?.hasError('minlength'); else pwdPattern2">Minimum 8 characters required</ng-container></ng-template>
        <ng-template #pwdPattern2>Must include uppercase, lowercase, number and special character</ng-template>
      </p>
      <app-text-input [img]="'../../../assets/password.png'" [is_login]="true" type="password" [mask]="true" [is_required]="true" class="w-full" [label]="'Confirm Password'" formControlName="confirm_password"></app-text-input>
    </div>
    <p *ngIf="reset_form.hasError('passwordMismatch') && reset_form.get('confirm_password')?.touched" class="text-red-500 text-sm text-center">
      Passwords do not match
    </p>
    <div class="flex justify-end items-center gap-2 mt-6">
      <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
      <app-button [disabled]="reset_form.value.new_password !== reset_form.value.confirm_password" color="bg-secondary text-black" label="Add" type="button" (click)="reset()"></app-button>
    </div>
  </form>
</app-modal>